/* eslint-disable */
import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
  ForwardRefRenderFunction,
} from "react";

import Modal from "../../components/ui/Modal";
import Dropdown from "../../components/ui/Dropdown";
import { getVendorCode, getSalesTeam } from "../../services/reviewPage";
import { useRecoilState, useRecoilValue } from "recoil";
import { declarationDefault, offlineSBM, selectVendor, transactionDetails, vendorCodes } from "../../store";
import { declarationDetails, UserTransactionDetails } from "../../store/store";
import clsx from "clsx";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

const DeclarationModal: ForwardRefRenderFunction<
  IDeclarationModal.IDeclarationModalHandles,
  IDeclarationModal.IDeclarationModalProps
> = ({ isDeclarationModal, setDeclarationModal, modalTitle, enableDelcaration, type }, ref) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  // const declarationData: declarationDetails = useRecoilValue(declarationDefault);

  const setTransactionData = useRecoilState(transactionDetails)[1];
  const [offlineSbmData, setOfflineSbmData] = useRecoilState(offlineSBM);
  const [defaultDeclaration, setDefaultDeclaration] = useRecoilState(declarationDefault);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDualTransaction, setShowDualTransaction] = useState(false);
  const [dualTransaction, setDualTransaction] = useState("No");
  const [disableDualTransaction, setDisableDualTransaction] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [onboardingInputValue, setOnboardingInputValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("No");

  const [showVendorCode, setShowVendorCode] = useState(false);

  const [showCity, setShowCity] = useState(false);
  const [showTransferType, setShowTransferType] = useState(false);
  const [confirmButton, setConfirmButton] = useState(false);
  const [disableUtr, setDisableUtr] = useState(true);

  const [data, setData] = useState<any>([]);
  const [onboardingData, setOnboardingData] = useState<any>([]);

  const [branch, setBranch] = useState<any>([]);
  const [transferType, setTransferType] = useState<any>(["GIC", "FLYWIRE", "Others"]);

  const [trxnDeclarations, setTrxnDeclarations] = useState<any>(defaultDeclaration);
  const selectedVendorCode = useRecoilValue(selectVendor);

  const prevVendorCodeRef = useRef<string | null>(trxnDeclarations?.vendorCode);

  const lanMandatoryCheck = localStorage.getItem("lanMandatory");

  useEffect(() => {
    setShowDropdown(false);
    setShowTransferType(false);
    setShowCity(false);
    setShowDualTransaction(false);
  }, [isDeclarationModal]);

  useMemo(() => {
    setConfirmButton(
      lanMandatoryCheck === "true"  ?
      trxnDeclarations?.docSufficient !== null && trxnDeclarations?.takeCover !== null && trxnDeclarations?.lanNumber !== null
      :
      trxnDeclarations?.docSufficient !== null && trxnDeclarations?.takeCover !== null
    );
  }, [trxnDeclarations, dropdownValue,lanMandatoryCheck]);

  useMemo(() => {
    setDisableUtr(dropdownValue === "No");
    dropdownValue === "No" &&
      setTrxnDeclarations((prevState: any) => ({ ...prevState, paymentUtr: "" }));
  }, [dropdownValue]);

  useMemo(() => {
    setDisableDualTransaction(dualTransaction === "No");
    dualTransaction === "No" &&
      setTrxnDeclarations((prevState: any) => ({ ...prevState, dualTransactionNumber: "" }));
  }, [dualTransaction]);

  useEffect(() => {
    if (trxnDeclarations?.vendorCode !== prevVendorCodeRef.current) {
      setTrxnDeclarations((prevState: any) => ({ ...prevState, branchName: "select" }));
      if (trxnDeclarations?.vendorCode == "select") {
        setBranch([]);
      }
    }
    prevVendorCodeRef.current = trxnDeclarations?.vendorCode;
  }, [trxnDeclarations?.vendorCode]);

  useEffect(() => {
    isDeclarationModal && setTrxnDeclarations(defaultDeclaration);
  }, [defaultDeclaration]);

  useEffect(() => {
    getVendorCode(currentUser)
      .then((response: any) => {
        setData(response?.data);
      })
      .catch((error: any) => console.error("Error", error));
  }, []);

  useEffect(() => {
    getSalesTeam(currentUser)
      .then((response: any) => {
        setOnboardingData(response?.data);
      })
      .catch((error: any) => console.error("Error", error));
  }, []);

  const resetForm = () => {
    setDualTransaction("No");
    setDropdownValue("No");
    setInputValue("");
    setOnboardingInputValue("");
  };

  useImperativeHandle(ref, () => ({
    clearState: resetForm,
  }));

  const sortBranch = (value: any) => {
    const selectedIndex = data.findIndex((x: any) => x?.vendorCode === value);
    setBranch(data?.[selectedIndex]?.branch);
  };

  const confirmDeclaration = () => {
    const data = {
      vendorCode: selectedVendorCode?.vendorCode,
      branchName: trxnDeclarations?.branchName == "select" ? null : trxnDeclarations?.branchName,
      lanNumber: trxnDeclarations?.lanNumber,
      dualTransaction: dualTransaction == "No" ? false : true,
      dualTransactionNumber: trxnDeclarations?.dualTransactionNumber,
      docSufficient: trxnDeclarations?.docSufficient,
      takeCover: trxnDeclarations?.takeCover,
      paymentUtr: trxnDeclarations?.paymentUtr,
      paymentReceived: dropdownValue == "No" ? false : true,
      transferType: trxnDeclarations?.transferType,
      salesUniqueKey: trxnDeclarations?.salesUniqueKey,
    };

    if (type === "offline") {
      setOfflineSbmData({ ...offlineSbmData, trxnDeclarations: data });
    } else {
      setTransactionData({ ...transactionData, trxnDeclarations: data });
    }

    setDeclarationModal(false);
    enableDelcaration(true);
    setDefaultDeclaration(trxnDeclarations);
  };
  // window.console.log("data",data && data?.map(x=>x?.vendorCode))

  return (
    <Modal
      modalClass="!p-0 md:pr-11 flex p-0 flex-col !rounded lg:w-6/12 md:w-11/12 sm:w-11/12 "
      headerClass="!mt-0 items-center text-white sticky h-24 pr-4 pl-[40%] bg-primary font-bold text-2xl"
      visible={isDeclarationModal}
      header={modalTitle ? modalTitle : "Declaration Detail"}
      closeHandler={() => {
        setDeclarationModal(false);
        // setTrxnDeclarations(declarationDefault);
      }}
    >
      <div className="bg-white w-full lg:h-full md:h-screen">
        <div className="p-4 h-full overflow-auto">
          <div className="flex flex-col justify-center items-center py-2 w-full lg:px-2 xs:px-1">
            {/* {data?.map((value:any,key:any)=>( */}
            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Vendor Code*</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 justify-start px-5">
                {/* <span className="font-semibold text-black-100">{value?.value}</span>
                  <DropdownIcon /> */}
                <Autocomplete
                  value={selectedVendorCode?.vendorCode}
                  onChange={(event: any, newValue: string | null) => {
                    setTrxnDeclarations({ ...trxnDeclarations, vendorCode: newValue });
                    sortBranch(newValue);
                    event.stopPropagation();
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={data?.length > 0 ? data?.map((x: any) => x?.vendorCode) : ["Select"]}
                  style={{ width: "100%", marginTop: "15px" }}
                  renderInput={(params) => <TextField {...params} label="Vendor Code" />}
                  disabled
                />
              </div>
            </div>
            <div className="grid grid-cols-12 w-full mt-3">
              <div className="flex max-w-2xl col-span-4 w-full h-full items-center">
                <span className="font-semibold text-gray-500">Branch ( City )</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 justify-start px-1">
                {/* <span className="font-semibold text-black-100">{value?.value}</span>
                  <DropdownIcon /> */}
                <Dropdown
                  showDropdown={showCity}
                  dropdownButtonOnClick={() => {
                    setShowCity((prev) => !prev);
                    setShowVendorCode(false);
                  }}
                  onBlur={() => setShowCity(false)}
                  dropdownLabel="Branch"
                  list={branch}
                  disabled={Boolean(branch < 1)}
                  dropdownClassname="w-40 p-0"
                  dropdownBodyClassname="w-40"
                  dropdownValue={trxnDeclarations?.branchName}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    setTrxnDeclarations({ ...trxnDeclarations, branchName: e.target.textContent });
                    setShowCity(false);
                  }}
                />
              </div>
            </div>

            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">LAN no ( If any ){lanMandatoryCheck === "true" ? "*":""}</span>
              </div>
              <div className=" flex w-full col-span-8 justify-start">
                <input
                  value={trxnDeclarations?.lanNumber}
                  onChange={(e: any) =>
                    setTrxnDeclarations({ ...trxnDeclarations, lanNumber: e.target.value })
                  }
                  placeholder="Enter LAN Number"
                  className="px-5 py-3 mx-5 my-3 w-full bg-blue-100 border-2 border-gray-300 rounded-lg"
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Dual Transaction</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 items-center justify-start px-2">
                <Dropdown
                  showDropdown={showDualTransaction}
                  dropdownButtonOnClick={() => setShowDualTransaction((prev) => !prev)}
                  dropdownLabel="Dual Transaction"
                  onBlur={() => setShowDualTransaction(false)}
                  list={["Yes", "No"]}
                  dropdownClassname="w-auto p-0"
                  dropdownBodyClassname="w-auto h-auto"
                  dropdownValue={dualTransaction}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    setDualTransaction(e.target.textContent);
                    setShowDualTransaction(false);
                  }}
                />
                <input
                  value={trxnDeclarations?.dualTransactionNumber}
                  onChange={(e: any) =>
                    setTrxnDeclarations({
                      ...trxnDeclarations,
                      dualTransactionNumber: e.target.value,
                    })
                  }
                  placeholder="Enter Dual Transaction"
                  className="px-5 py-3 mx-5 ml-2 my-3 bg-blue-100 border-2 border-gray-300 w-full rounded-lg"
                  autoComplete="off"
                  disabled={disableDualTransaction}
                />
              </div>
            </div>

            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Documents sufficient*</span>
              </div>
              <div className="max-w-3xl flex w-full px-6 col-span-8 justify-start">
                <div className="mr-2">
                  <input
                    onChange={() =>
                      setTrxnDeclarations({ ...trxnDeclarations, docSufficient: true })
                    }
                    type="radio"
                    id="document_yes"
                    name="document"
                    value="Yes"
                    checked={trxnDeclarations?.docSufficient}
                  />
                  <label className="ml-3">Yes</label>
                </div>
                <div className="mr-2">
                  <input
                    onChange={() =>
                      setTrxnDeclarations({ ...trxnDeclarations, docSufficient: false })
                    }
                    type="radio"
                    id="document_no"
                    name="document"
                    value="No"
                    checked={trxnDeclarations?.docSufficient === false}
                  />
                  <label className="ml-3">No</label>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 w-full mt-5">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Take Cover*</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 justify-start">
                <div className="max-w-3xl flex w-full px-6 justify-start">
                  <div className="mr-2">
                    <input
                      onChange={() => setTrxnDeclarations({ ...trxnDeclarations, takeCover: true })}
                      type="radio"
                      id="take_over_yes"
                      name="take_over"
                      value="Yes"
                      checked={trxnDeclarations?.takeCover}
                    />
                    <label className="ml-3">Yes</label>
                  </div>
                  <div className="mr-2">
                    <input
                      onChange={() =>
                        setTrxnDeclarations({ ...trxnDeclarations, takeCover: false })
                      }
                      type="radio"
                      id="take_over_no"
                      name="take_over"
                      value="No"
                      checked={trxnDeclarations?.takeCover === false}
                    />
                    <label className="ml-3">No</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Payment Received*</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 items-center px-2 justify-start">
                {/* <span className="font-semibold text-black-100">{value?.value}</span>
                  <DropdownIcon /> */}
                <Dropdown
                  showDropdown={showDropdown}
                  dropdownButtonOnClick={() => setShowDropdown((prev) => !prev)}
                  dropdownLabel="Payment Received"
                  list={["Yes", "No"]}
                  dropdownClassname="w-auto p-0"
                  dropdownBodyClassname="w-auto h-auto"
                  onBlur={() => setShowDropdown(false)}
                  dropdownValue={dropdownValue}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    setDropdownValue(e.target.textContent);
                    setShowDropdown(false);
                  }}
                />
                <div className="flex max-w-3xl w-20 h-full items-center">
                  <span className="text-gray-500 font-light">UTR no</span>
                </div>
                <div className="max-w-3xl flex w-full justify-start">
                  <input
                    value={trxnDeclarations?.paymentUtr}
                    onChange={(e: any) =>
                      setTrxnDeclarations({ ...trxnDeclarations, paymentUtr: e.target.value })
                    }
                    placeholder="Enter UTR Number"
                    className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-full rounded-lg"
                    autoComplete="off"
                    disabled={disableUtr}
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 w-full">
              <div className="flex max-w-3xl col-span-4 w-60 h-full items-center">
                <span className="font-semibold text-gray-500">Onboarded by</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 justify-start px-5">
                <Autocomplete
                  value={
                    trxnDeclarations?.salesUniqueKey &&
                    onboardingData?.find(
                      (x: any) => x?.uniqueKey === trxnDeclarations?.salesUniqueKey && x?.name,
                    )
                  }
                  onChange={(event: any, newValue: any) => {
                    setTrxnDeclarations({
                      ...trxnDeclarations,
                      salesUniqueKey: newValue?.uniqueKey ?? null,
                    });
                    setOnboardingInputValue(newValue?.name ?? null);
                    newValue && event.stopPropagation();
                  }}
                  inputValue={onboardingInputValue}
                  onInputChange={(event, newInputValue) => {
                    setOnboardingInputValue(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={
                    onboardingData?.length > 0
                      ? onboardingData
                      : [{ name: "Select", uniqueKey: "" }] // Provide an object with a name property
                  }
                  getOptionLabel={(option) => option.name} // Use the name property as the label
                  style={{ width: "100%", marginTop: "15px" }}
                  renderInput={(params) => <TextField {...params} label="Onboarded by" />}
                />
              </div>
            </div>

            <div className="grid grid-cols-12 w-full mt-3">
              <div className="flex max-w-2xl col-span-4 w-full h-full items-center">
                <span className="font-semibold text-gray-500">Transfer type</span>
              </div>
              <div className="max-w-3xl flex w-full col-span-8 justify-start px-1">
                {/* <span className="font-semibold text-black-100">{value?.value}</span>
                  <DropdownIcon /> */}
                <Dropdown
                  showDropdown={showTransferType}
                  dropdownButtonOnClick={() => {
                    setShowTransferType((prev) => !prev);
                  }}
                  dropdownLabel="Transfer Type"
                  list={transferType}
                  dropdownClassname="w-40 h-12 p-0"
                  dropdownBodyClassname="w-40 h-16 overflow-auto"
                  dropdownValue={trxnDeclarations?.transferType}
                  onBlur={() => setShowTransferType(false)}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    setTrxnDeclarations({
                      ...trxnDeclarations,
                      transferType: e.target.textContent,
                    });
                    setShowTransferType(false);
                  }}
                />
              </div>
            </div>

            {/* ))} */}
          </div>
          <div className="flex items-center w-full h-full my-2 justify-center mt-5">
            <div className="w-1/3 flex justify-center rounded-lg">
              <input
                type={"submit"}
                onClick={confirmDeclaration}
                disabled={!confirmButton}
                className={clsx(
                  confirmButton
                    ? "py-3 font-bold text-white rounded-lg cursor-pointer justify-center bg-primary text-[18px] w-full"
                    : "py-3 font-bold text-white rounded-lg cursor-not-allowed justify-center bg-gray-200 text-[18px] w-full",
                )}
                value={`Confirm`}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.forwardRef(DeclarationModal);
